__turbopack_context__.v({
  "heading": "gUnEma_heading",
  "section": "gUnEma_section",
});
